module.exports = __webpack_public_path__ + "img/page-share.b710db42.jpg";